import type { PropsWithChildren } from "react"
import { useTranslation } from "react-i18next"
import { ModalButton } from "../controls"
import { AdminOnly, icons } from "../utils"

interface IProps {
  title: string
}

export function SetupActivity({ children, title }: PropsWithChildren<IProps>) {
  const { t } = useTranslation()

  return (
    <AdminOnly>
      <ModalButton label={t("Settings")} title={title} leftSection={<icons.Settings />}>
        {children}
      </ModalButton>
    </AdminOnly>
  )
}
